<template>
    <div class="form-row">
        <div class="input-group col">
            <div class="input-group-prepend">
                <span class="input-group-text">
                    <span class="fa fa-calendar" />
                </span>
            </div>
            <date-picker
                ref="datepicker"
                v-model="date"
                :config="dateconfig"
                @dp-show="fillDate"
                @dp-change="updateDate"
            />
            <input
                v-model="ISODate"
                type="hidden"
                autocomplete="off" 
                :name="name"
                :required="required"
            >
            <div
                v-if="dow"
                class="input-group-append"
            >
                <span class="input-group-text">
                    <strong>{{ dow }}</strong>
                </span>
            </div>
        </div>
        <div class="input-group col">
            <div class="input-group-prepend">
                <span class="input-group-text">
                    <span class="fa fa-clock-o" />
                </span>
            </div>
            <date-picker
                ref="timepicker"
                v-model="time"
                :config="timeconfig"
                @dp-show="fillTime"
                @dp-change="updateTime"
            />
        </div>
        <button
            v-if="presets.length"
            type="button" 
            class="btn btn-secondary btn-sm dropdown-toggle dropdown-toggle-split" 
            data-toggle="dropdown" 
            aria-haspopup="true" 
            aria-expanded="false"
        />
        <div
            v-if="presets.length > 0"
            class="dropdown-menu"
        >
            <span 
                v-for="(item, index) in validPresets"
                :key="index"
                class="dropdown-item pointer"
                @click.prevent="setFromPreset(index)"
            >
                {{ getTypeName(item.type, item.day) }} <strong>{{ getDowName(item.day) }}</strong> {{ item.time }}
            </span>
        </div>
    </div>
</template>

<script>
    import datePicker from 'vue-bootstrap-datetimepicker';
    import moment from 'moment';
    moment.locale('ru');

    export default {
        name: 'DatetimePicker',
        props: {
            val: {
                type: String,
                default: '',
            },
            name: {
                type: String,
                default: 'startinternalDate',
            },
            required: {
                type: Boolean,
                default: true,
            },
            invalid: {
                type: Boolean,
                default: false,
            },
            preset: {
                type: String,
                default: '' 
            }
        },
        data: function() {
            return { 
                date: null, 
                internalDate: null,
                time: null, 
                internalTime: null, 
                dow: '',
                ISODate: '',
                dateIsSet: false,
                timeIsSet: false,
                valid: false,
                presets: [],
                dateconfig: {
                    minDate: moment().startOf('d'),
                    format: 'DD.MM.YYYY',
                    locale: 'ru',
                    useCurrent: false,
                    icons: {
                        time: 'fa fa-clock',
                        date: 'fa fa-calendar',
                        up: 'fa fa-arrow-up',
                        down: 'fa fa-arrow-down',
                        previous: 'fa fa-chevron-left',
                        next: 'fa fa-chevron-right',
                        today: 'fa fa-calendar-check',
                        clear: 'fa fa-trash-alt',
                        close: 'fa fa-times-circle'
                    }
                },
                timeconfig: {
                    minDate: moment().startOf('d'),
                    format: 'HH:mm',
                    locale: 'ru',
                    stepping: 5,
                    icons: {
                        time: 'fa fa-clock',
                        date: 'fa fa-calendar',
                        up: 'fa fa-arrow-up',
                        down: 'fa fa-arrow-down',
                        previous: 'fa fa-chevron-left',
                        next: 'fa fa-chevron-right',
                        today: 'fa fa-calendar-check',
                        clear: 'fa fa-trash-alt',
                        close: 'fa fa-times-circle'
                    }
                }
            }
        },
        computed: {
            validPresets: function(){
                return this.presets.filter(x => x.day && x.type && x.time);
            },
        },
        watch: {
            date: function (val) {
                this.emitChange(val);
            },
            time: function (val) {
                this.emitChange(val);
            },
        },
        mounted: function() {
            if (this.val) {
                this.internalDate = moment(this.val);
                this.internalTime = moment(this.val);
                this.date = moment(this.val);
                this.time = moment(this.val).format('HH:mm')
                this.dateIsSet = true;
                this.timeIsSet = true;
            }
            if (this.preset) {
                this.presets = JSON.parse(this.preset);
            }
        },
        methods: {
            fillDate: function(e) {
                if (!this.dateIsSet) {
                    this.date = moment();
                    this.internalDate = moment();
                    this.dateIsSet = true;
                }
            },
            fillTime: function(e) {
                if (!this.dateIsSet) {
                    this.fillDate();
                }
                if (!this.timeIsSet) {
                    this.time = moment().add(1,'hours').format('HH:mm');
                    this.internalTime = moment().add(1,'hours');
                    this.timeIsSet = true;
                }
            },
            updateDate: function(e) {
                if (e.date) {
                    this.internalDate = moment(e.date);
                    this.dow = moment(e.date).format('dd');
                } else {
                    this.internalDate = null;
                    this.internalTime = null;
                    this.dow = '';
                    this.ISODate = '';
                }
            },
            updateTime: function(e) {
                if (e.date) {
                    this.internalTime = moment(e.date);
                } else {
                    this.internalTime = null;
                    this.ISODate = '';
                }
            },
            combine: function(t) {
                return moment(this.internalDate).set({ hour: this.internalTime.hours(), minute: this.internalTime.minutes()})
            },
            emitChange: function(val) {
                if (this.internalTime) {
                    let dt = this.combine();

                    this.dow = dt.format('dd');


                    if (dt.isBefore(moment().add(5,'m'))) {
                        this.timeconfig.minDate = moment().add(5, 'm');
                    } else {
                        if (this.timeconfig.minDate.diff(moment().startOf('d'), 'm')){
                            this.timeconfig.minDate = moment().startOf('d');
                        }
                    }

                    this.ISODate = dt.toISOString();
                    this.$emit('change', dt);
                }
            },
            setFromPreset: function(index) {
                let preset = this.presets[index];
                let newDate = moment();
                let time = preset.time.split(':');

                if (preset.type == 'this') {
                    newDate.days(preset.day);
                    if (newDate.isBefore(moment())) {
                         newDate = newDate.days(preset.day+7);
                    }
                } else if (preset.type == 'next') {
                    newDate.days(preset.day+7);
                }

                newDate.set({hour: time[0], minute: time[1]});

                this.timeconfig.minDate = moment().startOf('d');
                this.date = newDate;
                this.time = newDate.format('HH:mm');
                this.internalDate = newDate;
                this.internalTime = newDate;
                this.dateIsSet = true;
                this.timeIsSet = true;
            },
            getDowName: function(val){
                return moment().day(val).format('dddd')
            },
            getTypeName: function(val, day){
                    if (val == 'this') {
                        if ([1, 2, 4].includes(day)){
                            return 'ближайший';
                        } else if ([3, 5, 6].includes(day)) {
                            return 'ближайшая';
                        } else {
                            return 'ближайшее';
                        }
                    } else if (val == 'next'){
                        if ([1, 2, 4].includes(day)){
                            return 'cледующий';
                        } else if ([3, 5, 6].includes(day)) {
                            return 'cледующая';
                        } else {
                            return 'cледующее';
                        }
                    } else {
                        return '?';
                    }
            }
        },
    }
</script>
